// extracted by mini-css-extract-plugin
module.exports = {"universalloader":"mQocKv","wrapper":"MbNQ3F","logo":"tQKA8P","fade-in-from-none":"IJKSpH","universalloader--translucent":"v2fVVp"};